import { createSlice } from "@reduxjs/toolkit";

export const sessionSlice = createSlice({
    name: "session",
    initialState: {
        deviceId: null,
        corrId: null,
        token: null,
        sKey: null,
        selfService: {
            "is_active": false,
            "self_service_id": "",
            "intent_id": 0,
            "intent": ""
        },
        qrcodeUrl: null,
        selfServicesStatus: true
    },
    reducers: {
        setDeviceId: (state, action) => {
            state.deviceId = action.payload;
        },
        setCorrId: (state, action) => {
            state.corrId = action.payload;
        },
        setToken: (state, action) => {
            state.token = action.payload;
        },
        clearToken: (state) => {
            state.token = null;
        },
        setSKey: (state, action) => {
            state.sKey = action.payload;
        },
        setSelfService: (state, action) => {
            state.selfService = action.payload;
        },
        resetSelfService: (state) => {
            state.selfService = {
                "is_active": false,
                "self_service_id": "",
                "intent_id": 0,
                "intent": ""
            };
        },
        setQrcodeUrl: (state, action) => {
            state.qrcodeUrl = action.payload
        },
        setSelfServiceStatus: (state, action) => {
          state.selfServicesStatus = action.payload
        }
    }
});

export const { setDeviceId, setCorrId, setToken, clearToken, setSKey, setSelfService, resetSelfService, setQrcodeUrl, setSelfServiceStatus } = sessionSlice.actions;

export default sessionSlice.reducer;